export enum CarListErrorCauses {
    ERROR = 'error',
    NO_RESULTS = 'no-results',
}

export class CarListError extends Error {
    cause: CarListErrorCauses;

    errorName: string;

    constructor(cause: CarListErrorCauses) {
        super();
        this.cause = cause;
        this.name = 'CarListError';
    }
}
